import React from "react";
import {
    Grid,
    Card,
    Avatar,
    Typography,
} from "@material-ui/core";
import MainScreen from "./templates/MainScreen";
import { makeStyles } from "@material-ui/core/styles";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import AnswerPlay from "../components/AnswerPlay";
import ProgressbarGame from "../components/ProgressBarGame";
import QuestionPlay from "../components/QuestionPlay";
import { useAnswer } from "../../viewmodel/hooks/getAnswer";
import { Color } from "../../model/answer";
import { usePlayQuestion } from "../../viewmodel/hooks/getPlayQuestion";
import UserInfo from "../../model/userInfo";
import { orange } from "@material-ui/core/colors";

const useStyles = makeStyles(() => ({
    avatar: {
        width: "40px",
        height: "40px",
        margin: ".25rem",
    },
    answersGrid: {
        height: "100%",
    },
    questionDiv: {
        flexGrow: 0.12,
        minWidth: "70%",
        paddingLeft: "2rem",
        paddingRight: "2rem",
    },
    centerHorizontal: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    centerCountdown: {
        position: "absolute",
        width: "60%",
    },
    col3: {
        width: "33%",
    },
    marginBottom: {
        marginBottom: "2rem",
    },
}));

type GameProps = {
    user: UserInfo,
    question: string;
    options: string[];
    duration: number;
    questionNumber: number,
    chooseOption?: Function,
    correctOption?: string,
}

export default function PlayQuestionPractice(
    { user, question, options, duration, questionNumber, chooseOption, correctOption }: GameProps): JSX.Element {
    const classes = useStyles();
    const answersContents = options;
    const circleColor="orange";

    const [state, setChosenOption] = usePlayQuestion();

    const [answer1] = useAnswer(answersContents[0]);
    const [answer2] = useAnswer(answersContents[1]);
    const [answer3] = useAnswer(answersContents[2]);
    const [answer4] = useAnswer(answersContents[3]);
    const answers = [answer1, answer2, answer3, answer4];

    function selectAnswer(i: number) {
        if (state.optionChosen === -1) {
            setChosenOption(i);
            if (chooseOption)
                chooseOption(i);
        }
    }

    const answersElems = answers.map(
        (t, i) => {
            const choosen1: boolean = state.optionChosen === i;
            let color: Color = Color.Black;
            const opt = String.fromCharCode(97 + i);
            if ((choosen1) && correctOption !== undefined)
                color = Color.Red;
            if (correctOption !== undefined && correctOption === opt)
                color = Color.Green;

            return (
                <AnswerPlay
                    key={`${questionNumber}:${i}`}
                    text={t.content} color={color} player1={choosen1} player2={false} clickFunc={selectAnswer} id={i}
                />);
        },
    );

    const sendDefaultAnswer = () => {
        if (duration !== 0) selectAnswer(-2);
    };

    const countdown = (
        <CountdownCircleTimer
            key={questionNumber}
            duration={duration}
            size={70} strokeWidth={5} isPlaying={state.optionChosen === -1}
            colors={[
                ["#008000", 0.33],
                ["#FFA500", 0.33],
                ["#A30000", 0.33],
            ]}
            onComplete={() => sendDefaultAnswer()}
        >
            {({ remainingTime }) => remainingTime}
        </CountdownCircleTimer>
    );

    return (
        <MainScreen lower={false} back={true} fullWidth={true}>
            <Grid container direction="column" justify="space-evenly" className={classes.answersGrid}>
                <Card elevation={0} className={`${classes.centerHorizontal} ${classes.questionDiv}`}>
                    <Grid container direction="row">
                        <div className={classes.centerCountdown}>
                            <ProgressbarGame player={user} percentage={50} left={true} />
                        </div>
                        <Grid className={`${classes.centerHorizontal} ${classes.marginBottom}`}>
                            {countdown}
                        </Grid>
                    </Grid>
                    <Avatar style ={{ backgroundColor: circleColor}}>
                        <Typography variant="h6" style={{ color: "black" }}>
                        <Grid item>
                            {questionNumber}
                        </Grid>
                        </Typography>
                    </Avatar>
                    <QuestionPlay
                        question={question}
                    />
                </Card>
                {answersElems}
            </Grid>
        </MainScreen>
    );
}
